import ClassNames from "classnames";
import { FunctionComponent, useRef } from "react";
import moduleBaseStyles from "../stylesheets/components/module-base.module.css";
import styles from "../stylesheets/components/portal-widget.module.css";
import {
  PortalWidgetSettings,
  WidgetInstance,
  WindowState,
} from "../types/index.js";
import HgvWidgetContainer from "./HgvWidgetContainer.js";

interface Props {
  settings: PortalWidgetSettings;
  className?: string;
}

const PortalWidget: FunctionComponent<Props> = ({ className, settings }) => {
  const ref = useRef<HTMLDivElement>(null);
  const widgetInstanceRef = useRef<WidgetInstance>(undefined);

  const initWidget = () => {
    if (!ref.current) return;

    const { BookingSüdtirol } = window as unknown as WindowState;
    widgetInstanceRef.current = BookingSüdtirol.Widgets.Portal(
      ref.current,
      settings,
    );
  };

  return (
    <div className={ClassNames(moduleBaseStyles.Module__Wrapper, className)}>
      {settings.id && (
        <HgvWidgetContainer
          widgetInstance={widgetInstanceRef.current}
          initWidget={initWidget}
          settings={settings}
          enableLazyload={true}
        >
          <div className={styles.PortalWidget__Container} ref={ref} />
        </HgvWidgetContainer>
      )}
      {!settings.id && (
        <div className={styles.PortalWidget__Empty}>Portalwidget</div>
      )}
    </div>
  );
};

export default PortalWidget;
